import { useToast, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { QuoteApi } from "../api/QuoteApi";
import QuoteTableContainer from "../components/QuoteTableContainer";
import useUser from "../hooks/useUser";
import { Quote } from "../lib/models/quote.model";
import { QuoteUtils } from "../lib/quote-utils";

function BorrowerByIdQuotesView() {
  const user = useUser();
  const toast = useToast();
  const toastVariant = useColorModeValue("subtle", "solid");
  const { id } = useParams<{ id: string }>();
  const { sfProfile } = user;
  const history = useHistory();
  const { sfAccounts } = useUser();

  const [quotes, setQuotes] = React.useState<Quote[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [borrower, setBorrower] = React.useState<any>();

  const fetchQuotes = React.useCallback(() => {
    setLoading(true);

    QuoteApi.getBorrowerQuoteById(id)
      .then((res) => {
        const activeQuotes = res.data.map((x) => {
          x.quoteTypeLabel = QuoteUtils.PrettyPrintQuoteType(x.quoteType);
          x.createdBy = `${x.firstname} ${x.lastname}`;
          return x;
        });

        setQuotes(activeQuotes);
      })
      .catch((err) => {
        toast({
          title: "Unable to Load Quotes",
          description: "An error has occurred when attempting to fetch quotes",
          status: "error",
          variant: toastVariant,
          isClosable: true,
          position: "top-right",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setQuotes, id, toast, toastVariant]);

  React.useEffect(() => {
    if (!id) return;

    if (sfAccounts) {
      const borrower = sfAccounts.find((x) => x.accountid === id);
      borrower ? setBorrower(borrower) : history.push("/quotes/my-quotes");
    }

    fetchQuotes();
  }, [fetchQuotes, id, sfProfile, history, sfAccounts]);

  return (
    <QuoteTableContainer
      refetchQuotes={fetchQuotes}
      loading={loading}
      title={`Quotes for ${borrower?.name}`}
      quotes={quotes}
      emptyTableLabel={`There are no quotes for ${borrower?.name}.`}
      showAddQuoteMenu={false}
    />
  );
}

export default BorrowerByIdQuotesView;
